import React from 'react'
import PropTypes from 'prop-types'

import { View, ViewPropTypes } from 'react-native'

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Step from './Step'
import Title from './Title'

import styles from './HorizontalStepper.Styles'


const renderSteps = (theme, steps, activeIndex, onStepPress, isEditMode) => {
  return steps.map((step, index) => (
    <Step
      theme={theme}
      index={index}
      noOfSteps={steps.length}
      activeIndex={activeIndex}
      onStepPress={onStepPress}
      isEditMode={isEditMode}
    />
  ))
}

const renderTitles = (theme, steps, activeIndex, onStepPress) => {
  return steps.map((step, index) => (
    <Title
      theme={theme}
      step={step}
      index={index}
      activeIndex={activeIndex}
      onStepPress={onStepPress}
    />
  ))
}

const HorizontalStepper = ({
  isEditMode,
  steps,
  activeStepIndex,
  style,
  theme,
  onStepPress,
  ...props
}) => {
  return (
    <View style={[styles.horizontalStepperStyle(theme), style]} {...props}>
      <View style={styles.stepsContainerStyle}>
        {renderSteps(theme, steps, activeStepIndex, onStepPress, isEditMode)}
      </View>
      <View style={styles.titlesContainerStyle}>
        {renderTitles(theme, steps, activeStepIndex, onStepPress)}
      </View>
    </View>
  )
}

HorizontalStepper.defaultProps = {
  activeStepIndex: 0,
  theme: LightThemeColors,
  isEditMode: false,
}

HorizontalStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      i18nKey: PropTypes.string.isRequired,
      accessibilityLabel: PropTypes.string,
    })
  ),
  activeStepIndex: PropTypes.number,
  style: ViewPropTypes.style,
  theme: PropTypes.object,
  onStepPress: PropTypes.func,
  isEditMode: PropTypes.bool,
}

export default withTheme(HorizontalStepper)
